<template>
  <li class="column is-6">
    <router-link class="column" :to="{name: 'Rubric', params: {rubricId : rubric.redirectId}}">
      <span>{{rubric.name}}</span>
      {{rubric.abstract}}
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'RubricTile',
  props: {
    rubric: {
      required: true,
      type: Object
    }
  }
}
</script>
